import { getAccessToken } from '../authentication/supabaseService';

export type SetupType = 'all' | 'food' | 'drinks' | 'other';
export interface SetupOverviewMetric {
  category: { completed: number; total: number; percentage: number | null };
  cost: { completed: number; total: number; percentage: number | null };
  score: number | null;
}
export interface SetupOverviewRestaurant {
  restaurantId: string;
  restaurantName: string;
  metrics: Record<SetupType, SetupOverviewMetric>;
}
export interface SetupOverviewItem {
  restaurantId: string;
  restaurantName: string;
  itemName: string;
  type: Exclude<SetupType, 'all'>;
  costPriceId: string | null;
  categoryId: string | null;
  categoryName: string | null;
  categoryColor: string | null;
  categorized: boolean;
  ingredientCount: number;
  costSetUp: boolean;
}
export interface SetupOverviewResponse {
  generatedAt: string;
  window: { days: number; from: string; toExclusive: string };
  aggregate: Record<SetupType, SetupOverviewMetric>;
  restaurants: SetupOverviewRestaurant[];
  items: SetupOverviewItem[];
}

export async function getSetupOverview(signal?: AbortSignal): Promise<SetupOverviewResponse> {
  const token = await getAccessToken();
  const response = await fetch('/api/setup-overview', {
    signal,
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error(`Failed to load setup overview: ${response.status}`);
  return response.json();
}
